import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import ReactDOM from "react-dom/client";
import { queryClient } from "shared/api/queryClient";
import App from "./app";
import reportWebVitals from "./reportWebVitals";
import theme from "./shared/theme";
import GlobalStyles from "./shared/theme/global";

LicenseInfo.setLicenseKey(
  process.env.REACT_APP_MUI_LICENSE_KEY || "no license",
);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <QueryClientProvider client={queryClient}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <App />
        {process.env.REACT_APP_NODE_ENV === "local" && (
          <ReactQueryDevtools buttonPosition="bottom-left" />
        )}
      </ThemeProvider>
    </StyledEngineProvider>
  </QueryClientProvider>,
);

reportWebVitals();
